import Toggle from '../toggle/toggle.js';
import { SCROLL } from '../app.config.js';
import BreakPoints from '../shared/_breakpoints.js';

export default class Nav extends BreakPoints {

	constructor(node, scroller) {
		super();
		this.node = node;
		this.scroller = scroller;

		this.selectors = {
			mainWrapper: 'body',
			mainNav: {
				attribute: '[data-nav-toggle]',
				target: '[data-nav-target]',
			}
		}

		this.settings = {
			activeClass: 'active',
			navOpen: '_main-nav'
		}

		this.wrapper = document.querySelector(this.selectors.mainWrapper);

		this.init();
	}

	init() {
		this.mainNav = Toggle.init(
			this.selectors.mainNav.attribute,
			this.selectors.mainNav.target,
			this.wrapper,
			this.settings.activeClass,
			this.callback.bind(this)
		);
	}

	callback({ type, item }) {
		switch (type) {
			case 'add':
				this.addClassHandler(item)
				break;
			case 'remove':
				this.removeClassHandler(item)
				break;
		}
	}

	addClassHandler() {
		this.wrapper.classList.add(this.settings.navOpen);
		// const head = document.querySelector('header');
		// head.style.overflow = 'initial';
		SCROLL && this.scroller.stop();
	}

	removeClassHandler() {
		this.wrapper.classList.remove(this.settings.navOpen);
		// setTimeout((x) => {
		// 	const head = document.querySelector('header');
		// 	head.style.overflow = 'auto';
		// }, 300)
		SCROLL && this.scroller.start();
	}
}
